import { createBlock } from "@wordpress/blocks";

/**
 * Attributes core/button and brandy/button both understand.
 *
 * Everything Brandy adds on top (icon, showText, animation, tagName, type)
 * takes its block.json default — a converted button is a plain one until the
 * author opts into the extras.
 */
const SHARED = [
  "url",
  "title",
  "text",
  "linkTarget",
  "rel",
  "textColor",
  "backgroundColor",
  "gradient",
  "width",
  "className",
];

const pick = (attributes) =>
  Object.fromEntries(
    SHARED.filter((key) => attributes[key] !== undefined).map((key) => [
      key,
      attributes[key],
    ])
  );

export default {
  from: [
    {
      type: "block",
      blocks: ["core/buttons"],
      /**
       * Parent attributes carry over wholesale: `layout` (and with it
       * justifyContent), spacing, colour and border are the same supports on
       * both blocks, so justification survives the conversion untouched.
       */
      transform: (attributes, innerBlocks) =>
        createBlock(
          "brandy/buttons",
          attributes,
          innerBlocks.map((button) =>
            createBlock("brandy/button", {
              ...pick(button.attributes),
              style: button.attributes.style,
            })
          )
        ),
    },
  ],
};
